/**
 * TanStack Query hooks for `empty-states-with-cta`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	emptyStatesWithCtaQueryKeys,
	type CreateEmptyStatesWithCtaBody,
	type ListEmptyStatesWithCtaResponse,
	type EmptyStatesWithCtaRow,
} from "./api";

export function useEmptyStatesWithCtaList(): UseQueryResult<ListEmptyStatesWithCtaResponse, Error> {
	return useQuery({
		queryKey: emptyStatesWithCtaQueryKeys.list(),
		queryFn: list,
	});
}

export function useEmptyStatesWithCtaCreate(): UseMutationResult<EmptyStatesWithCtaRow, Error, CreateEmptyStatesWithCtaBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: emptyStatesWithCtaQueryKeys.all });
		},
	});
}

export function useEmptyStatesWithCtaDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: emptyStatesWithCtaQueryKeys.all });
		},
	});
}
